
enum LayoutType {
    Horizontal = "Horizontal",
    Vertical ="Vertical"
}
export default LayoutType;